const theme = {
  token: {
    colorPrimary: '#54A2CC',
    colorSuccess: '#05A677',
    colorWarning: '#f5b759',
    colorError: '#FA5252',
    colorInfo: '#0948B3',
    borderRadius: 8,
    borderRadiusLG: 12,
    borderRadiusSM: 4,
    fontFamily: "'Nunito Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
    fontSize: 14,
    fontSizeLG: 16,
    fontSizeSM: 12,
    colorBgContainer: '#ffffff',
    colorBgLayout: '#f5f8fb',
    colorBgElevated: '#ffffff',
    colorText: '#262B40',
    colorTextSecondary: '#4A5073',
    colorTextTertiary: '#6b7280',
    colorTextQuaternary: '#9ca3af',
    colorBorder: '#e5e7eb',
    colorBorderSecondary: '#f3f4f6',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.04)',
    boxShadowSecondary: '0 4px 6px -1px rgba(0, 0, 0, 0.08), 0 2px 4px -1px rgba(0, 0, 0, 0.04)',
    controlHeight: 40,
    controlHeightLG: 48,
    controlHeightSM: 32,
    padding: 16,
    paddingLG: 24,
    paddingSM: 12,
    paddingXS: 8,
    margin: 16,
    marginLG: 24,
    marginSM: 12,
    marginXS: 8,
  },
  components: {
    Button: {
      primaryShadow: '0 2px 4px rgba(84, 162, 204, 0.3)',
      fontWeight: 600,
    },
    Card: {
      headerBg: '#f9fafb',
      borderRadiusLG: 12,
    },
    Table: {
      headerBg: '#f9fafb',
      headerColor: '#4A5073',
      rowHoverBg: '#f9fafb',
      borderColor: '#e5e7eb',
    },
    Menu: {
      darkItemBg: 'transparent',
      darkItemColor: 'rgba(255, 255, 255, 0.85)',
      darkItemHoverBg: 'rgba(255, 255, 255, 0.08)',
      darkItemSelectedBg: 'rgba(84, 162, 204, 0.2)',
      darkItemSelectedColor: '#54A2CC',
      darkSubMenuItemBg: 'rgba(0, 0, 0, 0.15)',
      itemBorderRadius: 8,
      subMenuItemBorderRadius: 8,
    },
    Layout: {
      siderBg: '#262B40',
      headerBg: '#ffffff',
      bodyBg: '#f5f8fb',
    },
    Input: {
      activeBorderColor: '#54A2CC',
      hoverBorderColor: '#9ca3af',
    },
    Select: {
      optionSelectedBg: 'rgba(84, 162, 204, 0.1)',
    },
    Statistic: {
      titleFontSize: 14,
      contentFontSize: 28,
    },
  },
};

export default theme;
